import legal from "@/content/legal.json";
import { AuthShell } from "@/components/AuthShell";

export default function Legal({ doc }) {
  const d = legal[doc];
  return (
    <AuthShell backLabel="Back">
      <p className="text-[11px] font-bold tracking-[0.3em] text-[#4CCC06]">LEGAL</p>
      <h1 className="mt-2 font-display text-4xl font-extrabold uppercase" data-testid="legal-title">{d.title}</h1>
      {d.updated && <p className="mt-1 text-xs text-neutral-500">Last updated: {d.updated}</p>}
      <div className="mt-6 space-y-6">
        {d.sections.map((s) => (
          <section key={s.title}>
            <h2 className="font-display text-lg font-bold text-white">{s.title}</h2>
            <p className="mt-1 text-sm leading-6 text-neutral-400">{s.body}</p>
          </section>
        ))}
      </div>
    </AuthShell>
  );
}
